import { render, staticRenderFns } from "./BinnacleView.vue?vue&type=template&id=47276ecc&scoped=true&"
import script from "./BinnacleView.vue?vue&type=script&lang=js&"
export * from "./BinnacleView.vue?vue&type=script&lang=js&"
import style0 from "./BinnacleView.vue?vue&type=style&index=0&id=47276ecc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47276ecc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47276ecc')) {
      api.createRecord('47276ecc', component.options)
    } else {
      api.reload('47276ecc', component.options)
    }
    module.hot.accept("./BinnacleView.vue?vue&type=template&id=47276ecc&scoped=true&", function () {
      api.rerender('47276ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/BinnacleView.vue"
export default component.exports